import '../css/master.scss';

import '../css/components/navigation.scss';
import '../css/components/footer.scss';
import '../css/components/pairings.scss';

import '../css/components/products.scss';
import '../css/components/services.scss';
import '../css/components/clients.scss';
import '../css/components/contact.scss';

import '../css/components/page-header.scss';


import '../css/pages/index.scss';
import '../css/pages/about.scss';
import '../css/pages/service.scss';

import * as markdown from './helpers/markdown';
import * as contact from './helpers/contact';

initialize();

/**
 * Initializes core functions of the pages
 */
function initialize() {
  let markdownElm = document.querySelector('[data-markdown]')
  let sliderElm = document.querySelector('.slider');

  let flicktyOptions = {
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    resize: true,
    autoPlay: 2000,
    pauseAutoPlayOnHover: false
  }

  if (markdownElm) {
    markdown.convert(markdownElm).then(() => {
      let sliderElm2 = document.querySelector('.slider');

      if (sliderElm2) {
        new Flickity(sliderElm2, flicktyOptions);
      }
    });
  } else if (sliderElm) {
    new Flickity(sliderElm, flicktyOptions);
  }

  contact.addContactListeners();
}